/**
 * Normalize any unknown error into a user-facing PT-BR copy string.
 *
 * Spec: docs/architecture/states-pattern.md §1.2.
 */
import { isApiError } from "@/lib/api/errors";

export function errorCopy(error: unknown): string {
  if (!isApiError(error)) return "Algo deu errado. Tente novamente.";
  switch (error.error.kind) {
    case "network":
      return "Sem conexão com o servidor. Verifique sua internet.";
    case "auth":
      return "Sua sessão expirou. Entre novamente para continuar.";
    case "validation":
      return error.error.message || "Dados inválidos.";
    case "server":
      return "O servidor está com problemas. Já estamos investigando.";
    case "unknown":
    default:
      return "Algo deu errado. Tente novamente.";
  }
}
